import $ from "jquery";

export const openModal = (id) => {
    $(`#${id}`).modal("show");
}

export const closeModal = (id) => {
    $(`#${id}`).modal("hide");
}